<template>
  <a
    :href="href"
    :class="[
      'sr-only',
      'text-text-primary',
      'bg-surface-primary',
      'focus:not-sr-only',
      'focus:absolute',
      'focus:py-16',
      'focus:px-24',
      'focus:left-0',
      'focus:top-0',
      'focus:border-md',
    ]"
  >
    {{ linkText }}
  </a>
</template>

<script lang="ts" setup>
interface Props {
  href: string;
  linkText?: string;
}

withDefaults(defineProps<Props>(), {
  linkText: 'Hoppa till innehåll',
});
</script>
